// Lựa chọn dùng chung cho form Đăng ký và trang Hồ sơ cá nhân

export const PHARMACY_SCALES = [
  { label: 'Sắp mở mới (Đang tìm mặt bằng / làm hồ sơ)', value: 'Sắp mở mới' },
  { label: 'Quầy thuốc nhỏ (1 người đứng quầy)', value: 'Quầy 1 người' },
  { label: 'Nhà thuốc đạt chuẩn (2 - 4 nhân sự)', value: 'Nhà thuốc 2-4 nhân sự' },
  { label: 'Chuỗi nhà thuốc (Từ 2 - 5 điểm bán)', value: 'Chuỗi 2-5 điểm' },
  { label: 'Dược sĩ / Sinh viên muốn học nâng cao', value: 'Cá nhân học tập' },
];
